import React, { useEffect, useState, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import Cookies from 'universal-cookie';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faClock, faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { faAddressBook } from '@fortawesome/free-regular-svg-icons';
import Logout from './logout';
import SvgGear from '../icons/svgGear';
import SvgDetailsIcon from '../icons/svgDetailsIcon';
import SvgSupport from '../icons/svgSupport';
import SvgInfoIcon from '../icons/svgInfoIcon';

import {
  signOut,
  toggleTempAnon,
} from '../actions';

const cookies = new Cookies();

const Dropdown = (props) => {
  const node = useRef();

  // const [isHide, setPersonalInfoHide] = useState(true);
  const [open, setOpen] = useState(false);

  const handleClickOutside = (e) => {
    if (node.current.contains(e.target)) {
      // inside click
      return;
    }
    // outside click
    setOpen(false);
  };

  const toggleShowInfo = () => {
    const { dispatch, tempAnon } = props;
    dispatch(toggleTempAnon(!tempAnon));
  };

  const handleLogout = (event) => {
    event.preventDefault();
    setOpen(false);
    const { dispatch, history } = props;
    dispatch(signOut(cookies, history)).then(() => {
      window.location.href = '/';
    });
  }

  useEffect(() => {
    if (open) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [open]);

  const location = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [location]);

  const isVerified = props.user && props.user.me && props.user.me.flags && props.user.me.flags.verified;

  const { tempAnon } = props;

  return (
    <div ref={node} className="drop-container">
      <FontAwesomeIcon
        onClick={toggleShowInfo}
        className="hide-icon"
        id="hide"
        size="lg"
        icon={tempAnon ? faEyeSlash : faEye}
      />
      <div className="drop-name" onClick={() => setOpen(!open)}>
        {isVerified ? (
          <FontAwesomeIcon
            style={{
              color: '#24C37E',
              paddingRight: '5px',
            }}
            id="verified"
            size="lg"
            icon={faCheck}
          />
        ) : (
          <FontAwesomeIcon
            style={{
              color: '#FAC317',
              paddingRight: '5px',
            }}
            id="pending"
            size="lg"
            icon={faClock}
          />
        )}
        <span
          className={tempAnon ? 'eyeblur' : ''}
          // style={
          //   {
          //     color: isHide ? 'transparent' : 'currentcolor',
          //     textShadow: isHide && '0 0 5px rgba(255, 255, 255, 0.5)',
          //   }
          // }
        >
          { props.user && props.user.me && props.user.me.identity && props.user.me.identity.firstName && props.user.me.identity.lastName ? (
            ' ' + props.user.me.identity.firstName + ' ' + props.user.me.identity.lastName + ' '
          ) : (
            ''
          )}
        </span>
        &#9662;
      </div>
      {open && (
        <div className="dropdown">
          <Link to="/settings" className="dropdown-item">
            <SvgGear />
            <p>Settings</p>
          </Link>
          <Link to="/addressbook" className="dropdown-item">
            <FontAwesomeIcon
              icon={faAddressBook}
              style={{
                maxWidth: '24px',
                maxHeight: '24px'
              }}
            />
            <p>Address Book</p>
          </Link>
          <a href="https://support.vaultoro.com/hc/en-us" target="_blank" rel="noopener noreferrer" className="dropdown-item">
            <SvgSupport />
            <p>Support</p>
          </a>
          <Logout handleLogout={handleLogout}/>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  user: state.user,
  tempAnon: state.user.tempAnon,
});

export default connect(mapStateToProps)(Dropdown);
